<template>
  <div class="addvip">
   <div class="content">
      <!-- 标题 -->
    <div class="title">
      <i class="el-icon-edit"></i>
      <span>修改会员信息</span>

      <!-- 返回按钮 -->
      <div class="back">
        <el-button round size='mini' class="back-btn" icon='el-icon-arrow-left' @click="back">返回</el-button>
      </div>
    </div>
    

    <!-- 表单内容 -->
    <el-form :model="form" class="main" size="medium" status-icon label-width="120px" ref="ruleForm">

      <!-- <el-form-item label="编号:" prop="no">
        <el-input v-model="form.no" disabled></el-input>
      </el-form-item> -->
       <el-form-item label="证书相片:" prop="link">
          <el-upload
            name="file"
            class="avatar-uploader"
            action=''
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :http-request="uploadFile"
          >
            <img v-if="this.form.img" :src="this.$store.state.ip+this.form.img" class="avatar"
             :rules="{ required: true, message: '请上传相片', trigger: ['click','submitForm']}"/>
             <!-- <img v-if="this.form.img" :src="this.form.img" class="avatar"
             :rules="{ required: true, message: '请上传相片', trigger: ['click','submitForm']}"/> -->
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      <!-- <el-form-item label="会员名称:" prop="name" >
        <el-input v-model="form.name" ></el-input>
      </el-form-item> -->
      <el-form-item label="会员编号:" prop="num" >
        <el-input v-model="form.num" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="身份证:" prop="tel"  >
        <el-input v-model="form.tel"  disabled></el-input>
      </el-form-item>
      <el-form-item label="会员类别:" prop="level">
        <el-input v-model="form.level" ></el-input>
      </el-form-item>
      <el-form-item label="注册日期:" prop="start">
       <el-input v-model="form.start" ></el-input>
      </el-form-item>
      <el-form-item label="会员到期时间:" prop="endTime" >
        <el-input v-model="form.endTime" disabled style="width:190px"></el-input>
        <el-button type="primary"  @click="setVip" v-show="data.c_status=='过期'">成为会员</el-button>
        <el-button type="primary"  @click="setVip" v-show="data.c_status=='有效'">续费会员</el-button>
        <span class="tiem-msg" v-show="time"> 已选择注册{{time}}个月会员 <span class="el-icon-close" @click="delTime"></span></span>
      </el-form-item>

      <el-form-item class="control">
        <el-button type="danger" icon="el-icon-close" @click="back">取消</el-button>
        <el-button @click="resetForm()" class="reset-btn" icon="el-icon-refresh-left">重置</el-button>
        <!-- <el-button type="primary"  @click="setPwd" class="btn-setPwd">重置密码</el-button> -->
        <el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-document-add">保存</el-button>
      </el-form-item>

      <el-dialog title="设置会员时限" :visible.sync="dialogVisible" :center="true" width="400px">
        <el-form :model="dialogForm">
          <el-form-item porp="time">
            <el-select v-model="dialogForm.time" placeholder="请选择会员有效期">
              <el-option label="一个月" value="1"></el-option>
              <el-option label="两个月" value="2"></el-option>
              <el-option label="三个月" value="3"></el-option>
              <el-option label="四个月" value="4"></el-option>
              <el-option label="五个月" value="5"></el-option>
              <el-option label="半年" value="6"></el-option>
              <el-option label="一年" value="12"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="chooseTime()">确 定</el-button>
        </div>
      </el-dialog>

      
    </el-form>
   </div>
  </div>
</template>
<script>
 export default {
    data() {
      
      return {
        dialogVisible: false,
        dialogForm:{
          time:""
        },
        data:{},
        form: {},
        type:0,
        time:0
      }
    },
    methods: {
      delTime(){
        this.time=0;
        this.dialogForm.time = '';
      },
      chooseTime(){
        this.dialogVisible = false
        this.time = this.dialogForm.time;
      },
      back(){//返回房产信息列表
        this.$router.push({path:'/home/vip'});
      },
      // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      handleChange(file) {
        this.file = file.raw
        console.log(this.file);
      },

      // 上传文件之前的钩子
      beforeUpload(file) {
        console.log("上传前");
        const isJPG = file.type === "image/jpeg"||"image/png";
       // const ispng = file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error("上传头像图片只能是 JPG或者png 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },

      // 自定义图片上传
      uploadFile() {
        // 创建表单对象
        let form = new FormData();
        // 后端接受参数 ，可以接受多个参数
        form.append("file",this.file)

        // 请求头设置文件上传
        let config = {
            //必须
          headers: {
              "Content-Type": "multipart/form-data"
          },
        }
        // 发送请求
        this.axios.post('/teacher/upload',form,config)
        .then(res=>{
          console.log(res.data)
          if(res.data.code=='200'){
            this.form.img = res.data.url;
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },


      // 提交表单
      submitForm(formName) {
        this.form.operater=sessionStorage.getItem("tel");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$confirm("此操作会将数据永久性修改，确认是否继续操作?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(()=>{
              console.log("seccess!",this.form);
              this.axios.post('/teacher/findTel',{
                tel:this.form.tel
                //id:this.form.uid
                //role:1
              })
              .then(res=> {
                console.log(res.data);
                if(res.data.code == 0){
                  this.$message.error(res.data.msg);
                }
                else{

                  this.axios.post("/vip/alter",{
                    id:this.data.no,
                    num:this.form.num,
                    tel:this.form.tel,
                    img:this.form.img,
                    name:this.data.name,
                    start:this.form.start,
                    operater:this.form.operater,
                    endTime:this.data.endTime,
                    time:this.time,
                    type:this.data.c_status
        
                  })
                  .then(res=>{
                    console.log(res);
                    if(res.data.code=='200'){
                      this.$message.success(res.data.msg);
                      this.$router.push({path:'/home/vip'});
                    }
                  })
                  .catch(err=>{
                    console.log(err);
                  })
                }
              })
              .catch(err=>{
                console.log(err)
              })
              
            })
            .catch(()=>{
              this.$message.info("已取消修改");
            })
            

            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },

      // 重置表单
      resetForm() {
        // this.$refs[formName].resetFields();
        this.form=this.formateData(this.data);
      },

      // 格式化数据
      formateData(item){
        var data={};
        // data.id=item.v_id;
        // data.uid = item.u_id;
        // data.no=this.PrefixInteger(item.c_id,10);
        // data.name = item.c_name;
        // data.tel = item.c_tel;
        // data.birth = this.switchTimeFormat(item.c_birth);
        // data.sex = item.v_sex?'女':'男';
        // data.address = item.v_address;
        // data.endTime = item.v_state==1?this.switchTimeFormat(item.c_endTime):'非会员';
        // console.log(data);
        data.no=item.c_id
        data.tel=item.m_idNum
        data.name=item.c_cert
        data.level=item.c_level
        data.start=this.switchTimeFormat(item.c_startDate)
        //data.endTime=this.switchTimeFormat(item.c_endDate)
        data.endTime = item.c_status=="有效"?this.switchTimeFormat(item.c_endDate):'过期';
        data.num=item.c_num
        data.img=item.c_img
        data.operater=item.operater
        data.c_status=item.c_status
         console.log(data);
        return data;
      },

      // 格式化时间
      switchTimeFormat(time) {
        const dateTime = new Date(time);
        const year = dateTime.getFullYear();
        const month = dateTime.getMonth() + 1;
        const date = dateTime.getDate();
        return `${year}-${this.PrefixInteger(month,2)}-${this.PrefixInteger(date,2)}`;
      },

      // 格式化数字
      PrefixInteger(num, n) {
        return (Array(n).join(0) + num).slice(-n);
      },

      // 成为会员
      setVip(){
        this.dialogVisible=true;
      },

      // 重置密码
      // setPwd(){
      //   this.$confirm("此操作会将密码重置为手机号后六位，请确认是否继续操作?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   })
      //   .then(()=>{
      //     console.log("重置密码",this.data.u_id);
      //     this.axios.post('/users/setPwd',{
      //       tel:this.form.tel,
      //       id:this.data.u_id
      //     })
      //     .then(res=>{
      //       console.log(res.data)
      //       if(res.data.code=="200"){
      //         this.$message.success("重置密码成功");
      //       }
      //     })
      //     .catch(err=>{
      //       console.log(err);
      //     })
      //   })
      //   .catch(()=>{
      //     this.$message({
      //       type: "info",
      //       message: "已取消重置"
      //     });
      //   })
        

      // }

    },

    mounted() {//创建时获取数据
      console.log(this.$route.params.id);
      this.axios.post("/teacher/getVip", {
        id:this.$route.params.id
      })
      .then((res) => {
        console.log(res);
        if(res.data.code=='200'){
          this.loading=false;
          this.data = res.data.data;
          this.data= this.formateData(this.data);
          this.form=this.data;
        }
      })
      .catch(err=> {
        console.log(err);
      })
    },
  }
</script>
<style lang="less" scoped>
@import "../assets/less/base.less";
.tiem-msg{
  display: inline-block;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 10px;
  line-height: 36px;
  color:white;
  background: @yellowColor;
  span{
    margin-left: 10px;
  }
}
.addvip {
  color: @fontColor;
  background-color: white;
  min-height: 500px;
}
.content {
  background: white;
}
.title {
  padding: 15px 20px;
  border-top: 3px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
  i {
    margin-right: 2px;
  }
  .back {
    float: right;
    .back-btn{
      padding: 5px;
    }
  }
}
.main{
  padding: 20px;
}
.el-input--medium,.el-select,.time-input{
  width: 300px;
}
.reset-btn{
  background: @blueGreenColor;
  color: white;
  border-color: @blueGreenColor;
}
.el-form--inline .control{
  text-align: right;
  width: 100%;
}
.btn-setPwd{
  background: @yellowColor;
  border-color: @yellowColor;
}
</style>